module.exports = __webpack_public_path__ + "img/singapore.5ed77d71.png";